// extracted by mini-css-extract-plugin
module.exports = {"noIngredientsBlock":"no-ingredients_noIngredientsBlock__14Yox"};